/* ============================================================
   LA REVISTA «QUEDA PASEO» — el formulario de la banda

   Sustituye al test de la pauta. Ahora la banda solo pide el correo
   para mandar la revista, sin preguntas por el camino.

   DÓNDE SE ENCHUFA KLAVIYO. Las dos constantes de aquí abajo son lo
   único que hay que rellenar cuando exista la cuenta (son PÚBLICAS;
   la clave privada no toca esta web jamás):

      KLAVIYO_ID     el ID público de la cuenta —seis caracteres—
      KLAVIYO_LISTA  el ID de la lista a la que suscribir

   Mientras estén vacías, el formulario no envía nada: avisa por
   consola y le dice a la persona que no se ha podido. No se finge
   que ha ido bien.

   Textos: claves «revista.*» de es.json.
   ============================================================ */
(function () {
  'use strict';

  var KLAVIYO_ID    = '';
  var KLAVIYO_LISTA = '';

  function t(k) {
    return (window.VEVVIA_I18N && window.VEVVIA_I18N.t(k)) || '';
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-revista-form]'), function (form) {
    var aviso = form.querySelector('[data-revista-aviso]');
    var boton = form.querySelector('button[type=submit]');

    function decir(clave, clase) {
      if (!aviso) return;
      aviso.textContent = t(clave);
      aviso.className = 'revista-form__aviso' + (clase ? ' revista-form__aviso--' + clase : '');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var correo = (form.querySelector('[name=email]') || {}).value;
      correo = (correo || '').trim();
      var ok = (form.querySelector('[name=consentimiento]') || {}).checked;

      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(correo) || !ok) { decir('revista.falta', 'mal'); return; }

      var propiedades = { origen: 'revista queda paseo', pagina: location.pathname };

      if (!KLAVIYO_ID || !KLAVIYO_LISTA) {
        console.warn('[revista] Klaviyo sin configurar. Se habría enviado:', correo, propiedades);
        decir('revista.error', 'mal');
        return;
      }

      decir('revista.enviando');
      if (boton) boton.disabled = true;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: correo, properties: propiedades } } }
            },
            relationships: { list: { data: { type: 'list', id: KLAVIYO_LISTA } } }
          }
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('klaviyo ' + r.status);
          decir('revista.hecho', 'bien');
          form.classList.add('revista-form--hecho');
        })
        .catch(function (err) {
          console.error('[revista]', err);
          decir('revista.error', 'mal');
          if (boton) boton.disabled = false;
        });
    });
  });
})();
